import clone from 'lodash/cloneDeep';
import initialState from '../../../store/initialState';
import {
  ADD_TENANT_STARTING,
  ADD_TENANT_SUCCESS,
  ADD_TENANT_ERROR,
} from '../../../constants/actionTypes';

export default function addTenantReducer(state = initialState.addTenant, action) {
  switch (action.type) {
    case ADD_TENANT_STARTING: {
      const newState = clone(state);
      newState.saving = true;
      newState.saved = false;
      return newState;
    }

    case ADD_TENANT_SUCCESS: {
      const { data } = action;

      const newState = clone(state);
      newState.saving = false;
      newState.saved = true;
      newState.error = null;

      newState.newTenant = data.tenant;
      return newState;
    }

    case ADD_TENANT_ERROR: {
      const newState = clone(state);
      newState.saving = false;
      newState.saved = false;
      newState.error = action.err;
      return newState;
    }

    default: {
      return state;
    }
  }
}
